// Additional Content & Toggle Styling

jQuery(".toggle").click(function (e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass("show")) {
        $this.next().removeClass("show");
        $this.next().slideUp(350);
        $(".toggle").text("Read More");
    } else {
        $this
            .find(".additional-content .inner")
            .removeClass("show");
        $this
            .find(".additional-content .inner")
            .slideUp(350);
        $this.next().toggleClass("show");
        $this.next().slideToggle(350);
        $(".toggle").text("Hide");
    }
});


var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var content = this.parentElement.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}